import { find, isNull } from 'lodash/fp';
import { Strong } from '@ahmdigital/ui';
import replacePlaceholder from '@ahmdigital/logic/lib/content/offers/shared/replace-placeholder';

import logger from '../../../../logging';
import type { Offer, OfferRewards, Placeholder } from '../../types';

type PlaceholderSerializer = {
  offer: Offer;
  offerTypeId?: string;
  placeholders: Placeholder[] | undefined;
  rewards?: OfferRewards;
};

const placeholderSerializer =
  ({ offer, offerTypeId, placeholders, rewards }: PlaceholderSerializer) =>
  // @ts-expect-error - Automatic, Please fix when editing this file
  (value) => {
    const matchedPlaceholder = find({ _id: value?.node?._ref }, placeholders);
    const placeholderId = matchedPlaceholder?.identifier?.current;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | undefined' is not assignable to type 'string'.
    const result = replacePlaceholder({ offer, offerTypeId, placeholderId, rewards });

    if (isNull(result)) {
      logger
        .getLogger()
        .error('Failed to replace offer terms and conditions placeholder', { matchedPlaceholder, offer, value });
      return <Strong>[[PLACEHOLDER:{placeholderId}]]</Strong>;
    }
    return result;
  };

export default placeholderSerializer;
